

import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/Procurement Main 2.png'
import Aboutbg from '../Images/Procurement_1.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "At Jeyshawn Engineering Limited, our Procurement Services are designed to ensure timely, cost-efficient, and quality-assured sourcing of materials, equipment, and services essential for project success.",
    intro:
      "With an integrated global supply chain network and a team of experienced procurement professionals, we support clients across various industries including oil & gas, energy, construction, infrastructure, and marine sector from initial sourcing to ﬁnal delivery.",

    intro1:
      "Our Procurement Capabilities Includes:",

    intro2:
      "Strategic Sourcing & Vendor Management: Identiﬁcation, evaluation, and pre-qualiﬁcation of reliable suppliers and service providers globally.",

    intro3:
      "Material & Equipment Procurement: Sourcing of project-critical items including mechanical, electrical, instrumentation, piping (MEIP), structural steel, and safety equipment.",

    intro4:
      "Our procurement team work hand-in-hand with project management, engineering, and logistics functions to ensure smooth material ﬂow and reduce project delays. Whether as part of an EPCIC contract or a standalone service, Jeyshawn delivers procurement solutions that drive performance and reliability.",

  }
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];
// const currentHref = "/Procurement";

export default function Procurement() {
  return (
    <>
      <div className="img_carrierspr">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${Aboutbg})` }}>
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
            <p className="service-detail__intro">{services[0].intro4}</p>
            <p className="service-detail__intro">{services[0].intro5}</p>
            {/* {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))} */}
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer />
    </>
  );
}


 
